import gql from 'graphql-tag'

export const getProperty = gql`
  query($propertyId: Int!) {
    getProperty(propertyId: $propertyId) {
      id
      address
      city
      state
      zipCode
      currentCoverage
      loanNumber
      notes
      createdAt
      updatedAt
      additionalInfoStr
      quote {
        id
        name
      }
      recordType {
        id
        name
      }
      policy {
        id
        policyName
      }
      attachments {
        id
        type
        name
        size
        createdAt
        updatedAt
      }
      lienHolder {
        id
        name
      }
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
    }
  }
`

export const getProperties = gql`
  query($paging: PagingQuery, $order: PropertiesOrder, $filter: PropertiesFilter!) {
    getProperties(
      paging: $paging,
      order: $order,
      filter: $filter
    ) {
      properties {
        id
        address
        city
        state
        zipCode
        currentCoverage
        loanNumber
        notes
        createdAt
        updatedAt
        additionalInfoStr
        quote {
          id
          name
        }
        recordType {
          id
          name
        }
        policy {
          id
          policyName
        }
        attachments {
          id
          type
          name
          size
          createdAt
          updatedAt
        }
        lienHolder {
          id
          name
        }
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
      }
      paging { totalCount currentOffset currentLimit }
    }
  }
`

export const newProperty = gql`
  mutation($propertyInput: PropertyInput!) {
    newProperty(propertyInput: $propertyInput) {
      id
      address
    }
  }
`

export const editProperty = gql`
  mutation($propertyId: Int!, $propertyInput: PropertyInput!) {
    editProperty(
      propertyId: $propertyId,
      propertyInput: $propertyInput,
    ) {
      id
      address
    }
  }
`

export const deleteProperty = gql`
  mutation($propertyId: Int!) {
    deleteProperty(
      propertyId: $propertyId,
    )
  }
`
